/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Terms_Parse_Csv_FailedInputs */

const en_knp_terms_parse_csv_failed = /** @type {(inputs: Knp_Terms_Parse_Csv_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to parse CSV: ${i?.error}`)
};

const fr_knp_terms_parse_csv_failed = /** @type {(inputs: Knp_Terms_Parse_Csv_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l’analyse du CSV : ${i?.error}`)
};

const de_knp_terms_parse_csv_failed = /** @type {(inputs: Knp_Terms_Parse_Csv_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Parsen der CSV-Datei: ${i?.error}`)
};

const it_knp_terms_parse_csv_failed = /** @type {(inputs: Knp_Terms_Parse_Csv_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile analizzare CSV: ${i?.error}`)
};

const ru_knp_terms_parse_csv_failed = /** @type {(inputs: Knp_Terms_Parse_Csv_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось обработать CSV-файл: ${i?.error}`)
};

const es_knp_terms_parse_csv_failed = /** @type {(inputs: Knp_Terms_Parse_Csv_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al analizar CSV: ${i?.error}`)
};

const zh_cn2_knp_terms_parse_csv_failed = /** @type {(inputs: Knp_Terms_Parse_Csv_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`解析 CSV 文件失败：${i?.error}`)
};

const ja_knp_terms_parse_csv_failed = /** @type {(inputs: Knp_Terms_Parse_Csv_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CSV の解析に失敗しました: ${i?.error}`)
};

const hi_knp_terms_parse_csv_failed = /** @type {(inputs: Knp_Terms_Parse_Csv_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CSV फ़ाइल को पार्स करने में विफल: ${i?.error}`)
};

const pt_pt2_knp_terms_parse_csv_failed = /** @type {(inputs: Knp_Terms_Parse_Csv_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao analisar o arquivo CSV: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to parse CSV: {error}" |
*
* @param {Knp_Terms_Parse_Csv_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_parse_csv_failed = /** @type {((inputs: Knp_Terms_Parse_Csv_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Parse_Csv_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_parse_csv_failed(inputs)
	if (locale === "de") return de_knp_terms_parse_csv_failed(inputs)
	if (locale === "it") return it_knp_terms_parse_csv_failed(inputs)
	if (locale === "ru") return ru_knp_terms_parse_csv_failed(inputs)
	if (locale === "es") return es_knp_terms_parse_csv_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_parse_csv_failed(inputs)
	if (locale === "ja") return ja_knp_terms_parse_csv_failed(inputs)
	if (locale === "hi") return hi_knp_terms_parse_csv_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_parse_csv_failed(inputs)
	return en_knp_terms_parse_csv_failed(inputs)
});